import { useEffect } from "react";
import { TechnicianDetailSidebar } from "@/payroll/pay-breakdown/payroll-statement-notifications/technician-detail-sidebar";
import { usePacksSection } from "./packs-section-provider";

export const PacksSidebar = ({
  onOpenChange,
  registerClose,
}: {
  onOpenChange?: (open: boolean) => void;
  registerClose?: (close: (() => void) | null) => void;
} = {}) => {
  const {
    businessId,
    periodStart,
    detailRecipient,
    detailTechnicianId,
    sidebarView,
    setSidebarView,
    closeDetail,
    noteDrafts,
    setNoteDraft,
    previewOnly,
    projectionBuild,
  } = usePacksSection();

  useEffect(() => {
    registerClose?.(closeDetail);

    return () => registerClose?.(null);
  }, [closeDetail, registerClose]);

  useEffect(() => {
    onOpenChange?.(!!detailRecipient);

    return () => onOpenChange?.(false);
  }, [detailRecipient, onOpenChange]);

  return (
    <TechnicianDetailSidebar
      businessId={businessId}
      periodStart={periodStart ?? null}
      recipient={detailRecipient}
      view={sidebarView}
      onViewChange={setSidebarView}
      onClose={closeDetail}
      noteDraft={
        detailRecipient
          ? (noteDrafts[detailRecipient.technician_id] ??
            detailRecipient.note ??
            "")
          : ""
      }
      onNoteChange={(value) => {
        if (!detailTechnicianId) return;
        setNoteDraft(detailTechnicianId, value);
      }}
      previewOnly={previewOnly}
      projectionBuild={projectionBuild}
    />
  );
};
